import { FilterParams } from '@synergy/models';
import { ReactElement, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useSearchParams } from 'react-router-dom';

import { ROUTES } from '../../utils/routes';

export const SlugRedirect = (): ReactElement | null => {
    const { slug } = useParams<{ slug: string }>();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        searchParams.set(FilterParams.SpecialOffer, slug ?? '');
        searchParams.set(FilterParams.SpecialPrice, 'true');
        navigate({ pathname: ROUTES.searchPage, search: searchParams.toString() }, { replace: true });
    }, [navigate, searchParams, slug]);

    return null;
};
